<!--
 * @Author: 仙道
 * @Date: 2022-06-20 20:37:18
 * @LastEditTime: 2022-06-20 21:12:43
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/vueGridLayout/index.vue
-->
<template>
  <grid-layout
    :breakpoints="{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }"
    :col-num="colNum"
    :cols="{ lg: 3, md: 2, sm: 2, xs: 1, xxs: 1 }"
    :is-draggable="isDraggable"
    :is-mirrored="isMirrored"
    :is-resizable="isResizable"
    :layout.sync="layout"
    :margin="marginArr"
    :responsive="isResponsive"
    :row-height="rowHeight"
    :useStyleCursor="true"
  >
    <grid-item
      :h="item.h"
      :i="item.i"
      :key="item.i"
      :w="item.w"
      :x="item.x"
      :y="item.y"
      @moved="movedEvent"
      class="item"
      drag-allow-from=".dragger"
      v-for="item in layout"
    >
      <!-- 將数据外传 -->
      <slot :item="item" name="item"></slot>
    </grid-item>
  </grid-layout>
</template>

<script>
  import * as _ from 'lodash'
  import VueGridLayout from 'vue-grid-layout'
  export default {
    components: {
      GridLayout: VueGridLayout.GridLayout,
      GridItem: VueGridLayout.GridItem,
    },
    props: {
      indData: {
        type: Array,
        default: () => [],
      },
      colNum: {
        type: Number,
        default: 3,
      },
      rowHeight: {
        type: Number,
        default: 100,
      },
      isDraggable: {
        type: Boolean,
        default: false
      },
      isResizable: {
        type: Boolean,
        default: false
      },
      isMirrored: {
        type: Boolean,
        default: false
      },
      isResponsive: {
        type: Boolean,
        default: false
      },
      marginArr: {
        type: Array,
        default: () => [10, 20],
      },
      // 根据这个键返回排序后的数组，如果不设置，就返回整个排序后的对象
      sortKey: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        layout: [
          { x: 0, y: 0, w: 1, h: 1, i: '0', id: 1 },
          { x: 1, y: 0, w: 1, h: 1, i: '1', id: 2 },
          { x: 2, y: 0, w: 1, h: 1, i: '2', id: 3 },
          { x: 2, y: 1, w: 2, h: 1, i: '3', id: 4 },
          { x: 1, y: 1, w: 1, h: 1, i: '4', id: 5 },
        ],
      }
    },
    methods: {
      // 构造数据
      createLayout (arr) {
        const col = this.colNum
        const res = arr.map((item, index) => {
          item.x = index % col
          item.y = parseInt(index / 3)
          item.w = 1
          item.h = 1
          item.i = index + ''
          return item
        })
        return res
      },
      // 移动之后的事件
      movedEvent (i, newX, newY) {
        const arr = this.getMovedOrder().map((item) => {
          if (!this.sortKey) {
            return item
          } else {
            return item[this.sortKey]
          }
        })
        this.$emit('moved', arr)
      },
      getMovedOrder () {
        const newLayout = [...this.layout]
        // 先按y(行)排，再按x(列)排序
        newLayout.sort((a, b) => {
          if (a.y !== b.y) {
            return a.y - b.y
          } else {
            return a.x - b.x
          }
        })
        return newLayout
      },
    },

    watch: {
      indData: {
        handler (arr) {
          // 这里需要深拷贝，否则之后的操作会改变这个对象
          this.layout = this.createLayout(_.cloneDeep(arr))
        },
        deep: true,
        immediate: true
      },
    },
  }
</script>

<style lang="scss" scoped>

  .item {
    touch-action: none;
    width: 100%;
    height: 100%;
    border: 1px solid #5592e5;
    transition: all 0.2s;
    cursor: move;
    &:hover {
      transform: scale(1.05, 1.05);
    }
  }

</style>

